import React, { useState, useEffect } from "react";
import { X } from "lucide-react";
import { parse } from "marked";

const PolicyModal = ({ isOpen, onClose, type }) => {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isOpen || !type) return;
    setLoading(true);
    const file = type === "tnc" ? "/assets/docs/yooki_tnc.md" : "/assets/docs/yooki_pvc_policy.md";
    fetch(file)
      .then((res) => res.text())
      .then((text) => {
        setContent(parse(text));
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error loading policy markdown:", err);
        setContent("<p>Failed to load document.</p>");
        setLoading(false);
      });
  }, [isOpen, type]);

  if (!isOpen) return null;

  const title = type === "tnc" ? "Terms and Conditions" : "Privacy Policy";

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(15, 23, 42, 0.55)",
        backdropFilter: "blur(6px)",
        WebkitBackdropFilter: "blur(6px)",
        zIndex: 10000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
      }}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        style={{
          fontFamily: "'Source Sans 3', -apple-system, BlinkMacSystemFont, sans-serif",
          backgroundColor: "#FFFFFF",
          borderRadius: "16px",
          maxWidth: "800px",
          width: "100%",
          maxHeight: "85vh",
          display: "flex",
          flexDirection: "column",
          boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
          overflow: "hidden",
        }}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "18px 24px",
            borderBottom: "1px solid #E2E8F0",
          }}
        >
          <h2 style={{ fontSize: "20px", fontWeight: 700, color: "#1E293B", margin: 0 }}>
            {title}
          </h2>
          <button
            onClick={onClose}
            style={{
              background: "#F1F5F9",
              border: "none",
              borderRadius: "50%",
              width: "32px",
              height: "32px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#64748B",
            }}
          >
            <X size={18} />
          </button>
        </div>

        {/* Scrollable Markdown Body */}
        <div
          style={{
            fontFamily: "'Source Sans 3', -apple-system, BlinkMacSystemFont, sans-serif",
            flex: 1,
            overflowY: "auto",
            padding: "24px 28px",
            fontSize: "14px",
            lineHeight: "1.7",
            color: "#334155",
          }}
        >
          {loading ? (
            <div style={{ textAlign: "center", padding: "40px", color: "#64748B" }}>
              Loading document...
            </div>
          ) : (
            <div
              className="policy-markdown-content"
              dangerouslySetInnerHTML={{ __html: content }}
              style={{
                wordBreak: "break-word",
              }}
            />
          )}
        </div>

        {/* Footer */}
        <div
          style={{
            padding: "14px 24px",
            borderTop: "1px solid #E2E8F0",
            display: "flex",
            justifyContent: "flex-end",
            backgroundColor: "#F8FAFC",
          }}
        >
          <button
            onClick={onClose}
            style={{
              padding: "8px 20px",
              backgroundColor: "#2BA9D4",
              color: "#FFFFFF",
              border: "none",
              borderRadius: "8px",
              fontSize: "14px",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default PolicyModal;
